/**
 * @generated SignedSource<<9d354a4a35df50b3b4b1648990c46c2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductExpireBatchDeleteExpireDateMutation$variables = {
  productExpireBatchId: string;
  productId: string;
};
export type ProductExpireBatchDeleteExpireDateMutation$data = {
  readonly storeProduct: {
    readonly expireBatch: {
      readonly delete: boolean | null;
    } | null;
  } | null;
};
export type ProductExpireBatchDeleteExpireDateMutation = {
  response: ProductExpireBatchDeleteExpireDateMutation$data;
  variables: ProductExpireBatchDeleteExpireDateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productExpireBatchId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "productId"
      }
    ],
    "concreteType": "StoreProductMutation",
    "kind": "LinkedField",
    "name": "storeProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "productExpireBatchId"
          }
        ],
        "concreteType": "StoreProductExpireBatchMutation",
        "kind": "LinkedField",
        "name": "expireBatch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "delete",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductExpireBatchDeleteExpireDateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProductExpireBatchDeleteExpireDateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "fccb5c30c0c042ac6a93aa039eda79eb",
    "id": null,
    "metadata": {},
    "name": "ProductExpireBatchDeleteExpireDateMutation",
    "operationKind": "mutation",
    "text": "mutation ProductExpireBatchDeleteExpireDateMutation(\n  $productId: ID!\n  $productExpireBatchId: ID!\n) {\n  storeProduct(id: $productId) {\n    expireBatch(id: $productExpireBatchId) {\n      delete\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "be0fa696309fd74146aacd5182022d6d";

export default node;
